import React from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function TransferirContaModal({ show, onClose, onConfirm, title = 'TRANSFERIR ENTRE CONTAS', origem, idPrograma }) {
  const [contas, setContas] = React.useState([]);
  const [novaConta, setNovaConta] = React.useState('');

  React.useEffect(() => {
    if (!show) return;
    setNovaConta('');
    if (!idPrograma) {
      setContas([]);
      return;
    }
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    axios.get(`${API_BASE_URL.CONTA}/findByEscolaAndPrograma`, {
      params: { idEscola: cnpj, idPrograma },
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => {
      let data = Array.isArray(r.data) ? r.data : [];
      if (origem) data = data.filter(c => String(c.numConta) !== String(origem));
      function parseContaNum(numConta) {
        const m = String(numConta).match(/^(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      }
      const sorted = [...data].sort((a, b) => {
        const nA = parseContaNum(a.numConta);
        const nB = parseContaNum(b.numConta);
        if (nA !== nB) return nA - nB;
        return String(a.numConta).localeCompare(String(b.numConta));
      });
      setContas(sorted);
    }).catch(() => setContas([]));
  }, [show, origem, idPrograma]);

  if (!show) return null;

  function handleSubmit(e) {
    e.preventDefault();
    if (!novaConta) return;
    onConfirm(novaConta);
  }

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-warning text-dark" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-arrow-left-right me-2"></i>{title}</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Conta de origem</label>
                <input type="text" className="form-control form-control-sm" value={origem || ''} readOnly />
              </div>
              <div className="mb-3">
                <label className="form-label">Conta de destino *</label>
                <select className="form-select form-select-sm" value={novaConta} onChange={e => setNovaConta(e.target.value)} required>
                  <option value="">Selecione...</option>
                  {contas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                </select>
                {contas.length === 0 && <div className="text-muted small mt-1">Nenhuma outra conta disponível neste programa.</div>}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-warning" disabled={!novaConta}>Transferir</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransferirContaModal;
